// Floating stickers — mobile-friendly micro-animation.
// Each click emits ONE small sticker that floats upward.
// Spammable without overload — caps active sprites at MAX_VISIBLE.
import { useEffect, useState } from "react";
import { playStickerSound } from "../lib/soundEngine";

let counter = 0;
const MAX_VISIBLE = 28;     // hard cap so spamming the button can't lag the page
const DURATION    = 2800;   // ms — short enough that the queue empties quickly
const SIZE_MIN    = 26;
const SIZE_MAX    = 32;

export default function FloatingStickers({ trigger }) {
  const [flying, setFlying] = useState([]);

  useEffect(() => {
    if (!trigger) return;
    counter += 1;
    const size = SIZE_MIN + Math.random() * (SIZE_MAX - SIZE_MIN);
    const sprite = {
      key: counter,
      emoji: trigger.emoji,
      color: trigger.color,
      left: 8 + Math.random() * 84,     // 8-92% horizontal
      drift: -50 + Math.random() * 100, // gentle sway
      size,
    };

    // Cap total visible — drop oldest if needed (queue, not blocking)
    setFlying((f) => {
      const next = [...f, sprite];
      return next.length > MAX_VISIBLE ? next.slice(-MAX_VISIBLE) : next;
    });

    playStickerSound(trigger.animation || "float-spin");

    const t = setTimeout(() => {
      setFlying((f) => f.filter((x) => x.key !== sprite.key));
    }, DURATION + 200);
    return () => clearTimeout(t);
  }, [trigger]);

  return (
    <div className="sticker-layer" data-testid="sticker-layer">
      {flying.map((s) => (
        <div
          key={s.key}
          className="anim-float-up pointer-events-none absolute"
          style={{
            left: `${s.left}%`,
            bottom: "4%",
            color: s.color,
            fontSize: `${s.size}px`,
            "--drift": `${s.drift}px`,
            animationDuration: `${DURATION}ms`,
            textShadow: `0 0 6px ${s.color}44`,
          }}
        >
          {s.emoji}
        </div>
      ))}
    </div>
  );
}
